import LayerSwitcher = require("./ol3-layerswitcher/ol3-layerswitcher");
export = LayerSwitcher;